<template>
  <div id="app">
    <b-navbar
      shadow
      :mobile-burger="false"
      style="padding: 0"
      :fixed-top="true"
    >
      <template #brand>
        <div class="is-full is-flex is-justify-content-space-between">
          <b-navbar-item>
            <p class="logo is-size-5 pacifico">Tomo & Yui</p>
          </b-navbar-item>

          <b-navbar-item tag="div" v-if="showForm">
            <b-tag type="is-primary">
              <a
                class="has-text-white has-text-weight-normal"
                href="https://line.me/ti/g2/GWB8w3IQpRu6_8Ymwd_9U4u6ISkmlkkf5zY9Cw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default"
                target="_blank"
                >ビンゴ当選番号</a
              >
            </b-tag>
          </b-navbar-item>
        </div>
      </template>
    </b-navbar>

    <section class="mainview mb-6">
      <Splide
        :options="{
          type: 'loop',
          perPage: 1,
          autoplay: true,
          interval: 2500,
          pagination: false,
          arrows: false,
        }"
      >
        <SplideSlide>
          <img src="@/assets/img/slider/01.jpg" />
        </SplideSlide>
        <SplideSlide>
          <img src="@/assets/img/slider/02.jpg" />
        </SplideSlide>
        <SplideSlide>
          <img src="@/assets/img/slider/03.jpg" />
        </SplideSlide>
        <SplideSlide>
          <img src="@/assets/img/slider/04.jpg" />
        </SplideSlide>
        <SplideSlide>
          <img src="@/assets/img/slider/05.jpg" />
        </SplideSlide>
        <SplideSlide>
          <img src="@/assets/img/slider/06.jpg" />
        </SplideSlide>
        <SplideSlide>
          <img src="@/assets/img/slider/07.jpg" />
        </SplideSlide>
        <SplideSlide>
          <img src="@/assets/img/slider/08.jpg" />
        </SplideSlide>
        <SplideSlide>
          <img src="@/assets/img/slider/09.jpg" />
        </SplideSlide>
      </Splide>

      <!-- <b-carousel
        :autoplay="true"
        :autoplay-interval="3000"
        :pause-hover="false"
        :indicator="false"
        :indicator-inside="false"
        :indicator-background="false"
      >
        <b-carousel-item>
          <img src="@/assets/img/slider01.jpg" alt="Image 1" />
        </b-carousel-item>
        <b-carousel-item>
          <img src="@/assets/img/slider01.jpg" alt="Image 2" />
        </b-carousel-item>
        <b-carousel-item>
          <img src="@/assets/img/slider01.jpg" alt="Image 3" />
        </b-carousel-item>
        <b-carousel-item>
          <img src="@/assets/img/slider01.jpg" alt="Image 4" />
        </b-carousel-item>
        <b-carousel-item>
          <img src="@/assets/img/slider01.jpg" alt="Image 5" />
        </b-carousel-item>
      </b-carousel> -->

      <div class="mainview_title">
        <p
          class="is-size-5 has-text-centered pacifico has-text-weight-bold mainview_title_text"
        >
          {{ displayedText1 }}
        </p>
        <p
          class="is-size-5 has-text-centered pacifico has-text-weight-bold mainview_title_text"
        >
          {{ displayedText2 }}
        </p>
        <p class="is-size-5 has-text-centered kaisei has-text-weight-bold mt-3">
          二次会のご案内
        </p>
      </div>
    </section>

    <section class="content mt-4 mb-6">
      <div class="has-background-primary-light p-3 py-4">
        <p class="kaisei has-text-weight-bold">
          親愛なる皆様へ<br /><br />
          このたび、芳賀友彦 結衣の結婚式を記念して、
          二次会を開催する運びとなりました。<br /><br />
          ぜひ、リラックスした雰囲気の中でお楽しみいただければと思います。<br /><br />
          皆様にお会いできることを心より楽しみにしております！
        </p>
      </div>
    </section>

    <section
      v-if="showForm"
      id="join"
      class="content mt-4 mb-6"
      data-aos="fade-up"
    >
      <h2>ビンゴ当選番号</h2>
      <div class="card p-4">
        <p class="mb-4">LINE オープンチャットに送信します。</p>
        <b-button
          type="is-primary"
          tag="a"
          href="https://line.me/ti/g2/GWB8w3IQpRu6_8Ymwd_9U4u6ISkmlkkf5zY9Cw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default"
          target="_blank"
          expanded
        >
          LINE オープンチャット
        </b-button>
      </div>
    </section>

    <section class="content mt-4 mb-6" data-aos="fade-up">
      <h2>開催情報</h2>
      <blockquote class="pl-4">
        <div class="mb-3">
          <p class="mb-0 has-text-weight-bold">日時：</p>
          <p class="mb-0">3月22日(土) 20:00～22:00</p>
          <p class="is-size-7">※披露宴の閉式は19時を予定しております。</p>
        </div>
        <div>
          <p class="mb-0 has-text-weight-bold">場所：</p>
          <p class="mb-0">
            Roller Coast MinatoMirai
            <b-tag type="is-primary" class="ml-1">
              <a
                class="has-text-white"
                href="https://maps.app.goo.gl/CVxyot3vfBwXbSyv9"
                target="_blank"
              >
                Map
                <b-icon pack="fas" icon="external-link-alt" />
              </a>
            </b-tag>
          </p>
          <p class="is-size-7">※披露宴会場より徒歩10分</p>
        </div>
        <div v-if="showForm" class="mt-3">
          <p class="mb-0 has-text-weight-bold">会費：</p>
          <p>お一人様 6,000円</p>
        </div>
      </blockquote>
    </section>

    <section
      v-if="showForm"
      id="join"
      class="content mt-4 mb-6"
      data-aos="fade-up"
    >
      <h2>ご出欠</h2>
      <div class="card p-4">
        <p class="mb-4">出欠を下記フォームよりご回答ください。</p>
        <b-button
          type="is-primary"
          tag="a"
          href="https://forms.gle/HZqZyVDbQEtDPEUh7"
          target="_blank"
          expanded
          disabled
        >
          ご出欠登録フォームはこちら
        </b-button>
        <p class="mt-3 is-size-7">※回答期限: 2025年3月7日(金) 中</p>
      </div>
    </section>

    <section class="content mt-4 mb-6" data-aos="fade-up">
      <h2>タイムスケジュール</h2>
      <div class="card p-4">
        <b-table
          :data="schedule"
          :striped="false"
          :hoverable="false"
          :bordered="true"
          :mobile-cards="false"
          :narrowed="true"
          :show-header="false"
        >
          <b-table-column field="time" width="20%" centered>
            <template #default="props">
              {{ props.row.time }}
            </template>
          </b-table-column>
          <b-table-column field="event" centered>
            <template #default="props">
              {{ props.row.event }}
            </template>
          </b-table-column>
        </b-table>
        <p class="is-size-7 mt-2 mb-0">
          ※お店には22:30まで滞在できます（L.O.は22:00）
        </p>
      </div>
    </section>

    <section class="content mt-4 mb-6">
      <div class="card mb-5" data-aos="fade-up">
        <div class="card-image">
          <img style="display: block; width: 100%" src="@/assets/img/yui.jpg" />
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">芳賀 結衣</p>
              <p class="subtitle is-6">@motoEndo</p>
            </div>
          </div>

          <div>
            <div class="is-full is-flex" style="gap: 1rem; margin-bottom: 1em">
              <div class="is-half">
                <p class="mb-0 has-text-weight-bold">生年月日</p>
                <p>1997.06.19</p>
              </div>
              <div class="is-half">
                <p class="mb-0 has-text-weight-bold">血液型</p>
                <p>A型</p>
              </div>
            </div>
            <div class="is-full is-flex" style="gap: 1rem; margin-bottom: 1em">
              <div class="is-half">
                <p class="mb-0 has-text-weight-bold">出身地</p>
                <p>府中</p>
              </div>
              <div class="is-half">
                <p class="mb-0 has-text-weight-bold">特技</p>
                <p>モルック</p>
              </div>
            </div>
            <p class="mb-0 has-text-weight-bold">ニックネーム</p>
            <p>ゆいピー</p>
            <p class="mb-0 has-text-weight-bold">座右の銘</p>
            <p>失敗は成功のもと</p>
            <p class="mb-0 has-text-weight-bold">新郎の好きなところ</p>
            <p>よく笑う、任せてくれる、優しい</p>
          </div>
        </div>
      </div>

      <div class="card" data-aos="fade-up">
        <div class="card-image">
          <img
            style="display: block; width: 100%"
            src="@/assets/img/mohiko.jpg"
          />
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <p class="title is-4">芳賀 友彦</p>
              <p class="subtitle is-6">@hyperSalesForceEngenieer</p>
            </div>
          </div>

          <div>
            <div class="is-full is-flex" style="gap: 1rem; margin-bottom: 1em">
              <div class="is-half">
                <p class="mb-0 has-text-weight-bold">生年月日</p>
                <p>1997.12.10</p>
              </div>
              <div class="is-half">
                <p class="mb-0 has-text-weight-bold">血液型</p>
                <p>O型</p>
              </div>
            </div>
            <div class="is-full is-flex" style="gap: 1rem; margin-bottom: 1em">
              <div class="is-half">
                <p class="mb-0 has-text-weight-bold">出身地</p>
                <p>稲城とか</p>
              </div>
              <div class="is-half">
                <p class="mb-0 has-text-weight-bold">特技</p>
                <p>チャーハン作り</p>
              </div>
            </div>
            <p class="mb-0 has-text-weight-bold">ニックネーム</p>
            <p>ともくん、はがっち、もひこ、もひ坊、芳賀ザウルス、学生くん</p>
            <p class="mb-0 has-text-weight-bold">座右の銘</p>
            <p>許してちょんまげ</p>
            <p class="mb-0 has-text-weight-bold">新婦の好きなところ</p>
            <p>可愛い、引っ張ってくれる、優しい</p>
          </div>
        </div>
      </div>
    </section>

    <section class="content mt-4 mb-6" data-aos="fade-up">
      <img @click="openModal" class="banner" src="@/assets/img/banner.jpg" />
      <!-- モーダルを開くボタン -->
      <!-- <b-button type="is-primary" expanded @click="openModal">
        新郎新婦クイズ
      </b-button> -->
    </section>

    <section class="content mt-4 mb-6" data-aos="fade-up">
      <div class="has-background-primary-light p-3 py-4">
        <p class="kaisei">
          最後までお読みいただきありがとうございます。<br />
          <br />
          皆様と一緒に素敵なひとときを過ごせることを楽しみにしております！<br />
          ご質問などがあれば、お気軽にご連絡ください。<br />
          <br />
          新郎新婦&#x3000;芳賀友彦、芳賀結衣<br />
          &#x3000;&#x3000;幹事&#x3000;岩澤帝良、波多野有紀、永見優
        </p>
      </div>
    </section>

    <b-modal v-model="isBingoModalActive" class="custom-modal">
      <div
        class="modal-card"
        style="width: 100%; max-width: 90%; margin: 0 auto"
      >
        <section class="modal-card-body">
          <h2 class="is-size-6 has-text-weight-bold mb-3">
            ビンゴ当選番号の確認はコチラから
          </h2>
          <b-button
            type="is-primary"
            tag="a"
            href="https://line.me/ti/g2/GWB8w3IQpRu6_8Ymwd_9U4u6ISkmlkkf5zY9Cw?utm_source=invitation&utm_medium=link_copy&utm_campaign=default"
            target="_blank"
            expanded
          >
            LINE オープンチャット
          </b-button>
          <!-- <b-button class="mt-3" expanded @click="isBingoModalActive = false">
            閉じる
          </b-button> -->
        </section>
      </div>
    </b-modal>

    <!-- モーダル -->
    <b-modal v-model="isModalActive" @close="resetQuiz" class="custom-modal">
      <div
        class="modal-card"
        style="width: 100%; max-width: 90%; margin: 0 auto"
      >
        <!-- ヘッダー -->
        <header class="modal-card-head">
          <p class="modal-card-title">友彦&結衣クイズ</p>
          <button
            type="button"
            class="delete"
            @click="isModalActive = false"
          ></button>
        </header>

        <!-- 本文 -->
        <section class="modal-card-body">
          <div>
            <template v-if="!isQuizFinished">
              <template v-if="result === null">
                <p class="question-text">{{ currentQuestion.question }}</p>
              </template>
              <div v-if="result !== null">
                <img
                  style="min-height: 12.4rem"
                  :src="`/img/quiz/${currentQuestion.img}`"
                />

                <p class="result mt-4" :class="resultClass">
                  {{ resultMessage }}
                </p>
                <p v-if="result === 'incorrect'" class="has-text-danger">
                  正解は「{{ currentQuestion.correctAnswer }}」です。
                </p>
                <!-- 解説 -->
                <p v-if="result !== null" class="mt-4">
                  {{ currentQuestion.explanation }}
                </p>
              </div>
            </template>

            <!-- 最後の問題後の得点 -->
            <div v-if="isQuizFinished">
              <p class="has-text-weight-bold">クイズ終了！</p>
              <p>
                あなたの得点は {{ score }} / {{ questions.length }} 点です！
                <template v-if="score === questions.length">
                  <br />
                  全問正解！やるやん！
                  <br />
                  <a href="https://www.youtube.com/shorts/Io0uEE1iCjg"
                    >https://www.youtube.com/shorts/Io0uEE1iCjg</a
                  >
                  <br />
                  <br />
                  二次会中に新郎に「コーギーみた」でちょっとしたプレゼントあり！
                </template>
                <template v-else>
                  <p>また挑戦してね</p>
                </template>
              </p>
            </div>
          </div>
        </section>

        <!-- フッター (選択肢 + 次の問題ボタン / 閉じるボタン) -->
        <footer class="modal-card-foot">
          <div class="is-full">
            <div v-if="result !== null">
              <b-button v-if="!isQuizFinished" @click="nextQuestion" expanded>
                次の問題
              </b-button>

              <b-button
                v-if="isQuizFinished"
                @click="isModalActive = false"
                expanded
              >
                閉じる
              </b-button>
            </div>

            <div v-if="!isQuizFinished && result === null">
              <b-button
                v-for="(option, index) in currentQuestion.options"
                :key="index"
                :class="buttonClass(option)"
                @click="checkAnswer(option)"
                class="question-button"
                :disabled="result !== null"
                expanded
              >
                <!-- {{ String.fromCharCode(65 + index) }}： -->
                {{ option }}
              </b-button>
            </div>
          </div>
        </footer>
      </div>
    </b-modal>

    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          This website was created by the bride and groom, along with the
          organizers.
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import { Splide, SplideSlide } from "@splidejs/vue-splide";

export default {
  components: {
    Splide,
    SplideSlide,
  },
  data() {
    return {
      text1: "Tomohiko & Yui",
      text2: "Wedding Party",
      displayedText1: "",
      displayedText2: "",
      currentIndex1: 0,
      currentIndex2: 0,
      schedule: [
        { time: "20:00", event: "受付開始" },
        { time: "20:30", event: "開会の挨拶" },
        { time: "21:00", event: "ビンゴ大会" },
        { time: "22:00", event: "閉会の挨拶" },
      ],
      showForm: true,

      isModalActive: false,
      isBingoModalActive: false,
      currentQuestionIndex: 0,
      result: null,
      score: 0, // 得点を保持する
      isQuizFinished: false, // クイズ終了フラグ
      questions: [
        {
          question: "ふたりが初めてデートした場所は？",
          options: [
            "よみうりランド",
            "ディズニーランド",
            "スカイツリー",
            "お台場",
          ],
          correctAnswer: "ディズニーランド",
          explanation:
            "初デートがディズニーってすごい。ちなみに、初めて一緒に観た映画は「永遠のゼロ」らしい。重すぎる、、",
          img: "disneyland.jpg",
        },
        {
          question:
            "友彦は4ヵ国の血を引いています。日本、フィリピン、スペイン。残りの1ヵ国はどこでしょうか？",
          options: ["モンゴル", "ベトナム", "インド", "エジプト"],
          correctAnswer: "インド",
          explanation: "インドが発覚したのは高1のときらしい。びっくり",
          img: "india.jpg",
        },
        {
          question: "結衣が小さい頃から大事にしているぬいぐるみは？",
          options: ["ミッフィー", "プーさん", "ポムポムプリン", "キティちゃん"],
          correctAnswer: "ミッフィー",
          explanation:
            "長年一緒にいるので、今は相当ボロボロで誰にも見せたくないらしい。このサイトに画像載せたくて交渉したけど断られました、、いつか見たる",
          img: "miffy.jpg",
        },

        {
          question: "友彦がやる、結衣の機嫌が悪いときの対処法は？",
          options: [
            "アイスを買う",
            "犬の動画を見せる",
            "一緒にチョコザップに行く",
            "料理を作る",
          ],
          correctAnswer: "犬の動画を見せる",
          explanation: "今のイチオシは「スケボーやるコーギー」らしい",
          img: "dog_video.jpg",
        },
        {
          question: "結衣がいま1番好きなアイドルは？",
          options: [
            "Snow Man：目黒蓮",
            "なにわ男子：高橋恭平",
            "SixTONES：田中樹",
            "King & Prince：平野紫耀",
          ],
          correctAnswer: "なにわ男子：高橋恭平",
          explanation:
            "好きになったきっかけは、友彦似てると思ったかららしい。なんて素敵",
          img: "idol_yui.jpg",
        },
        {
          question: "友彦がいま1番好きなアイドルは？",
          options: [
            "King & Prince：永瀬廉",
            "Snow Man：ラウール",
            "SixTONES：田中樹",
            "なにわ男子：道枝駿佑",
          ],
          correctAnswer: "SixTONES：田中樹",
          explanation: "結衣の影響で、アイドル好きになったらしい。仲良し",
          img: "idol_tomohiko.jpg",
        },
        // {
        //   question: "",
        //   options: ["", "", "", ""],
        //   correctAnswer: "",
        //   explanation: "",
        // },

        // 他の質問を追加
      ],
    };
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex];
    },
    resultMessage() {
      return this.result === "correct" ? "正解です！" : "残念、不正解です…";
    },
    resultClass() {
      return this.result === "correct" ? "has-text-success" : "has-text-danger";
    },
  },
  mounted() {
    this.isBingoModalActive = true;
    this.showText1();
    AOS.init({
      duration: 1500, // アニメーションの持続時間 (ミリ秒)
      once: true, // 一度だけアニメーションを実行する
      // offset: 500, // アニメーションを開始する位置
      // anchorPlacement: "top-center", // アニメーションの開始位置
    });
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("public")) {
      this.showForm = false;
    }
  },
  methods: {
    showText1() {
      if (this.currentIndex1 < this.text1.length) {
        this.displayedText1 += this.text1[this.currentIndex1];
        this.currentIndex1++;
        setTimeout(this.showText1, 100); // 100ミリ秒ごとに1文字表示
      } else {
        this.showText2();
      }
    },
    showText2() {
      if (this.currentIndex2 < this.text2.length) {
        this.displayedText2 += this.text2[this.currentIndex2];
        this.currentIndex2++;
        setTimeout(this.showText2, 100); // 100ミリ秒ごとに1文字表示
      }
    },
    scrollToJoin() {
      const element = document.querySelector("#join");
      if (element) {
        const headerOffset = 80; // ヘッダーの高さを考慮
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },

    openModal() {
      this.isModalActive = true;
      this.score = 0; // クイズ開始時に得点をリセット
      this.isQuizFinished = false; // クイズ終了フラグをリセット
      this.resetQuiz();
    },
    resetQuiz() {
      this.currentQuestionIndex = 0;
      this.result = null;
      this.score = 0; // 得点をリセット
      this.isQuizFinished = false; // クイズ終了フラグをリセット
    },
    checkAnswer(option) {
      this.result =
        option === this.currentQuestion.correctAnswer ? "correct" : "incorrect";

      // 正解した場合、得点を1点加算
      if (this.result === "correct") {
        this.score++;
      }
    },
    nextQuestion() {
      if (this.currentQuestionIndex < this.questions.length - 1) {
        this.currentQuestionIndex++;
        this.result = null;
      } else {
        this.isQuizFinished = true; // クイズ終了フラグを立てる
      }
    },
    buttonClass(option) {
      return {
        "is-success":
          this.result === "correct" &&
          option === this.currentQuestion.correctAnswer,
        "is-danger":
          this.result === "incorrect" &&
          option !== this.currentQuestion.correctAnswer,
      };
    },
  },
};
</script>

<style type="text/sass">
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

.logo {
  color: Black;
}

.is-full {
  width: 100%;
}

.is-half {
  width: 50%;
}

.pacifico {
  font-family: "Pacifico", serif !important;
}

.kaisei {
  font-family: "kaisei Decol", serif !important;
}

.mainview {
  position: relative;
}

.mainview::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(0, 0, 0, 0.5); */
  pointer-events: none; /* クリックなどのイベントを透過させる */
}

.carousel-item img {
  display: block; /* 画像周りの余白を除去したい場合 */
  width: 100%; /* 必要に応じて設定 */
  /* filter: brightness(50%); 明るさを50%に調整 */
}

.mainview_title {
  margin-top: 3rem;
  /* position: absolute; */
  /* top: 50%; */
  /* left: 50%; */
  /* transform: translate(-50%, -50%); */
  /* color: white; */
  /* z-index: 1; */
  /* width: 100%; */
}

.mainview_title_text {
  height: 30px;
  width: 100%;
}

.footer {
  background-color: hsl(0, 0%, 98%);
  padding: 3rem 1.5rem 3rem !important;
  margin-top: 5rem;
}

.modal-close {
  display: none !important;
}

.question-button + .question-button {
  margin-top: 0.5rem;
}

.banner {
  display: block;
  width: 100%;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0px 0 1px rgba(10, 10, 10, 0.02);
  border-radius: 0.25rem;
  cursor: pointer;
}

@media (max-width: 768px) {
  .splide {
    min-height: calc(468.64 / 375 * 100vw); /* 適切な高さを指定 */
  }
}
</style>
